/**
 * L'apparence 3D choisie par l'admin pour chaque trousse (migration 0745) : forme et patron peint.
 * Lue UNE fois par session (32 lignes) et gardée ; l'admin la relit après chaque changement
 * (`invalidateTrousseLooks`).
 */
import type { SupabaseClient } from '@supabase/supabase-js';
import { supabase } from '@/lib/supabase';
import { TROUSSE_SHAPES, type TrousseShape } from './shapes';

const db = supabase as unknown as SupabaseClient;

export const TROUSSE_SKIN_BUCKET = 'trousse-skins';

export interface TrousseLook {
  shape: TrousseShape | null;
  skinPath: string | null;
}

let pending: Promise<Map<string, TrousseLook>> | null = null;

export function loadTrousseLooks(): Promise<Map<string, TrousseLook>> {
  if (!pending) {
    pending = (async () => {
      const { data, error } = await db.from('trousses').select('slug, shape, skin_path');
      if (error) throw new Error(error.message);
      const map = new Map<string, TrousseLook>();
      for (const r of (data ?? []) as { slug: string; shape: string | null; skin_path: string | null }[]) {
        map.set(r.slug, {
          shape: (TROUSSE_SHAPES as readonly string[]).includes(r.shape ?? '')
            ? (r.shape as TrousseShape)
            : null,
          skinPath: r.skin_path,
        });
      }
      return map;
    })().catch((e: unknown) => {
      pending = null; // on réessaiera au prochain affichage
      throw e;
    });
  }
  return pending;
}

export function invalidateTrousseLooks(): void {
  pending = null;
}

/** URL publique d'un patron peint. */
export function patronUrl(path: string): string {
  return db.storage.from(TROUSSE_SKIN_BUCKET).getPublicUrl(path).data.publicUrl;
}
